import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';

const listCss = ":host{position:relative;box-sizing:border-box}:host *,:host *:before,:host *:after{box-sizing:inherit}:host{--selected-color:#1ec95b;display:block;position:relative;overflow:hidden}.corner{display:none;background-color:var(--selected-color);height:100px;width:50px;position:absolute;top:0;left:0;z-index:1;justify-content:center;align-items:center;font-size:40px;transform:rotate(45deg) translate(-33px, -18px)}.corner tt-icon{color:white;transform:rotate(315deg) translate(5px, 5px)}.overlay{position:absolute;top:0;left:0;bottom:0;right:0;z-index:1;border:4px solid var(--selected-color);background-color:rgba(30, 201, 91, 0.2);opacity:0;transition:opacity var(--tt-transition-medium)}:host([selected]){outline:4px solid var(--selected-color)}:host([selected]) .overlay{border:none}:host([selected]) .corner{display:flex}:host([selectable]){cursor:pointer;user-select:none;--webkit-user-drag:none}";

const List = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.itemSelect = createEvent(this, "itemSelect", 7);
    /** TODO (noahlaux) find workaround for timeout. Right now the item doesn't exists before the tick */
    this.handleSlotChange = () => setTimeout(() => this.syncSelected());
    this.handleClick = (event) => {
      const target = event.target;
      const item = target.closest('tt-list-item');
      this.selectItem(item);
    };
    this.handleKeyDown = (event) => {
      // Make a selection when pressing enter
      if (event.key === 'Enter') {
        const item = this.getActiveItem();
        event.preventDefault();
        this.selectItem(item);
      }
      // Prevent scrolling when space is pressed
      if (event.key === ' ') {
        event.preventDefault();
      }
      // Move the selection when pressing down or up
      if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
        const items = this.getItems();
        const selectedItem = this.getActiveItem();
        if (!selectedItem)
          return;
        let index = items.indexOf(selectedItem);
        // TODO (noahlaux) describe flow
        if (items.length) {
          event.preventDefault();
          if (event.key === 'ArrowRight') {
            index++;
          }
          else if (event.key === 'ArrowLeft') {
            index--;
          }
          else if (event.key === 'Home') {
            index = 0;
          }
          else if (event.key === 'End') {
            index = items.length - 1;
          }
          if (index < 0) {
            index = 0;
          }
          if (index > items.length - 1) {
            index = items.length - 1;
          }
          items[index].focus();
          return;
        }
      }
    };
    this.selectedValues = [];
    this.multiple = false;
    this.maxSelected = Infinity;
  }
  /** Gets currently active element */
  getActiveItem() {
    return this.getItems().find((item) => item === document.activeElement);
  }
  getItems() {
    const slot = this.wrapper.querySelector('slot');
    if (!slot)
      return [];
    return [...slot.assignedElements({ flatten: true })].filter((el) => el.tagName.toLowerCase() === 'tt-list-item' && !el.disabled);
  }
  getSelectedItems() {
    return this.getItems().filter((item) => item.selected);
  }
  syncSelected() {
    this.selectedValues = this.getSelectedItems().map((item) => item.value);
    this.itemSelect.emit({ selectedValues: this.selectedValues });
  }
  selectItem(item) {
    if (item && !item.disabled) {
      const hasReachedMaximum = this.getSelectedItems().length >= this.maxSelected;
      if (hasReachedMaximum && item.selected === false) ;
      else {
        item.selected = !item.selected;
      }
      if (!this.multiple) {
        // Deselect all other items
        this.getItems()
          .filter((currentItem) => currentItem !== item)
          .forEach((item) => (item.selected = false));
      }
      this.syncSelected();
    }
  }
  render() {
    return (h(Host, { onClick: this.handleClick, onKeyDown: this.handleKeyDown }, h("div", { ref: (el) => {
        if (el)
          this.wrapper = el;
      } }, h("slot", { onSlotchange: this.handleSlotChange }))));
  }
  static get style() { return listCss; }
}, [1, "tt-list", {
    "selectedValues": [1040],
    "multiple": [4],
    "maxSelected": [2, "max-selected"]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["tt-list"];
  components.forEach(tagName => { switch (tagName) {
    case "tt-list":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, List);
      }
      break;
  } });
}

const TtList = List;
const defineCustomElement = defineCustomElement$1;

export { TtList, defineCustomElement };
